import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { switchMap, tap } from 'rxjs/operators';
import { AppConfigService } from '../config/app-config.service';
import { AuthService } from './auth.service';
import { User } from '../models/user.model';

@Injectable({
    providedIn: 'root'
})
export class UserService {
    private apiUrl: string;

    constructor(private http: HttpClient, private auth: AuthService, private configService: AppConfigService) {
        this.apiUrl = configService.value.apiUrl;
    }

    getSecureUserData(): Observable<User> {
        const url = `${this.apiUrl}api/User/secure-endpoint`;
        return this.auth.getHeaders().pipe(
            switchMap(headers => this.http.get<User>(url, { headers })),
            tap(user => this.auth.setDataUser(user))
        );
    }
}
